import clsx from "clsx";
import React from "react";

function Status(props:any){
    const {children,style,className,...rest} = props
    return <div className={clsx('d-flex justify-content-center align-items-center',className) } style={{padding:"8px" +
            " 5px",border:'none',borderRadius:"6px",fontSize:"12px",textAlign:"center",...style}} {...rest}>
        {children}
    </div>;
}

export default  Status
